import { SimpleForm } from 'react-admin';
import { Box } from '@mui/material';
import { SubrogationUploadForm } from './SubrogationUploadForm';

const MedicaidClaimUpload = () => {
  return (
    <SimpleForm toolbar={false}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          width: '100%',
          p: 4,
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 1000 }}>
          <SubrogationUploadForm />
        </Box>
      </Box>
    </SimpleForm>
  );
};

export default MedicaidClaimUpload;
